import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
// import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
// import islands, { islandOrder } from "../data/IslandsData";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import "../Destination/Destination.css";

const toDisplayList = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }

  if (typeof value === "string") {
    return value.split(/[,;\n]+/).map((item) => item.trim()).filter(Boolean);
  }

  return value == null ? [] : [String(value)];
};

const formatContactLabel = (key) =>
  key
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const getContactEntries = (contacts) => {
  if (!contacts || typeof contacts !== "object") return [];

  const entries = [];

  const addContacts = (value, label) => {
    if (Array.isArray(value)) {
      value.forEach((item) => addContacts(item, label));
    } else if (value && typeof value === "object") {
      Object.entries(value).forEach(([key, item]) =>
        addContacts(item, label ? `${label} ${formatContactLabel(key)}` : formatContactLabel(key))
      );
    } else if (value !== null && value !== undefined && String(value).trim()) {
      entries.push({ label, value: String(value).trim() });
    }
  };

  Object.entries(contacts).forEach(([key, value]) =>
    addContacts(value, formatContactLabel(key))
  );

  return entries;
};


export default function IslandPage() {
  const { slug = "" } = useParams();
  const normalizedSlug = slug.toLowerCase();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const slugMap = {
    antigua: "antigua and barbuda",
    barbuda: "antigua and barbuda",
    grenada: "grenada",
    stlucia: "st-lucia",
    // stThomas: "st-thomas",
    // stMarteen: "st maarten",
    stthomas: "st-thomas",
    stmaarten: "st maarten",
    tortola: "british virgin islands",
    trinidad: "trinidad and tobago",
    tobago: "trinidad and tobago",
  };

  useEffect(() => {
    loadIsland();
  }, [slug]);

  async function loadIsland() {
    try {
      setLoading(true);

      // const firestoreSlug = slugMap[slug] || slug;
      const firestoreSlug = slugMap[normalizedSlug] || normalizedSlug;


      console.log("URL slug:", slug);
      console.log("Firestore slug:", firestoreSlug);

      const q = query(
        collection(db, "islands"),
        where("slug", "==", firestoreSlug),
        where("enabled", "==", true)
      );

      const snap = await getDocs(q);

      console.log("Docs found:", snap.size);

      if (!snap.empty) {
        const d = snap.docs[0];

        console.log("Island data:", d.data());

        setData({
          id: d.id,
          ...d.data(),
        });
      } else {
        console.log("No matching island found");
        setData(null);
      }
    } catch (err) {
      console.error(err);
      setData(null);
    }

    setLoading(false);
  }
  if (loading) {
    return (
      <>
        <Navbar />
        <div
          className="destinations-container"
          style={{
            padding: "60px 20px",
            textAlign: "center",
          }}
        >
          <h2>Loading...</h2>
        </div>
        <Footer />
      </>
    );
  }

  if (!data) {
    return (
      <>
        <Navbar />

        <div
          className="destinations-container"
          style={{
            padding: "60px 20px",
            textAlign: "center",
          }}
        >
          <h2>Island not found</h2>

          <Link to="/destinations">
            Back to Destinations
          </Link>
        </div>

        <Footer />
      </>
    );
  }
  const languages = toDisplayList(data.language || data.languages);
  const contactEntries = getContactEntries(data.contacts);
  const isStMaarten = normalizedSlug === "stmaarten";
  const isFrench = typeof navigator !== "undefined"
    && navigator.language.toLowerCase().startsWith("fr");
  const islandTitle = isStMaarten
    ? (isFrench ? data.title_fr : data.title_en) || data.title
    : data.title;

  

  return (
    <>
      <Navbar />

      <div className="destinations-container island-detail-page">
        <div className="island-hero">
          <img src={data.hero} alt={`${data.name} hero`} className="island-hero-image" />
        </div>

        <section className="voyages-intro">
          <div className="voyages-titlewrap">
            <h2 className="voyages-heading">{islandTitle}</h2>
            <p className="voyages-subheading">{data.subtitle}</p>
          </div>
          <p className="voyages-description">{data.description}</p>
        </section>

        <section className="destination-resource-section">
          <h2>Destination Information</h2>

          <div className="destination-resource-grid">

            <div className="destination-resource-card">
              <h3>Currency</h3>
              <p>{data.currency || "Information coming soon."}</p>
            </div>

            <div className="destination-resource-card">
              <h3>Population</h3>
              <p>
                {data.population
                  ? Number(data.population).toLocaleString()
                  : "Information coming soon."}
              </p>
            </div>

            <div className="destination-resource-card">
              <h3>Language</h3>
              {languages.length > 1 ? (
                <ul>
                  {languages.map((language, index) => (
                    <li key={`${language}-${index}`}>{language}</li>
                  ))}
                </ul>
              ) : (
                <p>{languages[0] || "Information coming soon."}</p>
              )}
            </div>

            <div className="destination-resource-card">
              <h3>Time Zone</h3>
              <p>{data.timezone || "Information coming soon."}</p>
            </div>

            <div className="destination-resource-card">
              <h3>Immigration / Visa Information</h3>

              <p>
                {data.immigration?.summary ||
                  "Information coming soon."}
              </p>

              {data.immigration?.website && (
                <a
                  href={data.immigration.website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn More
                </a>
              )}
            </div>

            <div className="destination-resource-card">
              <h3>Tourism Board</h3>

              <p>
                {data.tourism?.summary ||
                  "Information coming soon."}
              </p>

              {data.tourism?.website && (
                <a
                  href={data.tourism.website}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Official Website
                </a>
              )}
            </div>

            <div className="destination-resource-card">
              <h3>Private Aviation</h3>

              <p>
                <strong>Airport:</strong>{" "}
                {data.aviation?.airport || "N/A"}
              </p>

              {data.aviation?.fbo && (
                <p>
                  <strong>FBO:</strong> {data.aviation.fbo}
                </p>
              )}

              {data.aviation?.permits && (
                <p>
                  <strong>Permits:</strong> {data.aviation.permits}
                </p>
              )}
            </div>

            <div className="destination-resource-card">
              <h3>Useful Local Contacts</h3>

              {contactEntries.length > 0 ? (
                <ul>
                  {contactEntries.map((contact, index) => (
                    <li key={`${contact.label}-${index}`}>
                      <strong>{contact.label}:</strong> {contact.value}
                    </li>
                  ))}
                </ul>
              ) : (
                <p>Information coming soon.</p>
              )}
            </div>

          </div>

          <div className="destination-directory-link-wrap">
            <Link
              to={`/directory?island=${slug}`}
              className="destination-directory-link"
            >
              View Services Directory for {data.name}
            </Link>
          </div>
        </section>

        {/* Extra info about destination section */}
        {/* {data.section1 && (
          <section className="island-split">
            <div className="island-split-img">
              {data.section1.image && (
                <img
                  src={data.section1.image}
                  alt={`${data.name} section`}
                />
              )}
            </div>

            <div className="island-split-text">
              <h3>{data.section1.title}</h3>
              <p>{data.section1.text}</p>
            </div>
          </section>
        )} */}

        {/* {data.section2 && (
          <section className="island-split alt">
            <div className="island-split-text">
              <h3>{data.section2.title}</h3>
              <p>{data.section2.text}</p>
            </div>

            <div className="island-split-img">
              {data.section2.image && (
                <img
                  src={data.section2.image}
                  alt={`${data.name} section`}
                />
              )}
            </div>
          </section>
        )} */}

        <section className="services-cta-explore">
          <div className="services-cta-box">
            <h3>Speak with our team today!</h3>
            <p>Your next adventure begins here.</p>
          </div>
          <Link to="/connect" className="explore-link">EXPLORE</Link>
        </section>

      </div>

      <Footer />
    </>
  );
}
